"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initRouting = void 0;
var clicks_1 = require("./clicks");
var clean_1 = require("./clean");
var navigate_1 = require("./navigate");
function initClean() {
    function cleanIfNeeded() {
        var hrefWithoutOrigin = location.href.substr(location.origin.length);
        if (hrefWithoutOrigin !== clean_1.clean(hrefWithoutOrigin))
            navigate_1.navigate(clean_1.clean(hrefWithoutOrigin), { replace: true });
    }
    cleanIfNeeded();
    window.addEventListener("popstate", cleanIfNeeded);
}
function initClicks() {
    clicks_1.handleLinkClicks(navigate_1.navigate);
}
function initRouting() {
    initClean();
    initClicks();
    initScrolling();
}
exports.initRouting = initRouting;
function initScrolling() {
    window.addEventListener("popstate", function () {
        var hash = location.hash;
        if (!hash)
            return;
        var el = document.querySelector(hash);
        if (!el)
            return;
        el.scrollIntoView();
    });
}
//# sourceMappingURL=init.js.map